// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yBkG","colMin":"styles_colMin__u_Uex"};